import {
  EnvironmentProviders,
  importProvidersFrom,
  inject,
  provideEnvironmentInitializer,
  Provider,
} from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { SOFTLINE_CONFIG_LOGIN_LINKS } from '@softapps/allgemein/login';
import { SOFTLINE_CONFIG_SETTINGS } from '@softline/application';
import {
  PasswordRepository,
  UserInfoService,
} from '@softline/auth';
import { Store, StoreModule } from '@softline/core';
import { SOFTLINE_FEATURE_TRANSLATION, TranslationStore } from '@softline/ui-core';
import { map } from 'rxjs/operators';
import { default as de } from '../i18n/de.json';
import { default as en } from '../i18n/en.json';
import { PASSWORD_SETTINGS_KEY } from './password.tokens';
import { SettingsComponent } from './settings/components/settings.component';
import { SOFTLINE_FEATURE_PASSWORD } from './password.shared';
import { PasswordStore } from './store/password.store';

export const passwordProviders: (Provider | EnvironmentProviders)[] = [
  provideEnvironmentInitializer(() => {
    const store = inject(Store);
    store.commit(SOFTLINE_FEATURE_TRANSLATION, TranslationStore.mutations.add, {
      module: 'password',
      language: 'de',
      translations: de,
    });
    store.commit(SOFTLINE_FEATURE_TRANSLATION, TranslationStore.mutations.add, {
      module: 'password',
      language: 'en',
      translations: en,
    });
  }),
  {
    provide: SOFTLINE_CONFIG_LOGIN_LINKS,
    useValue: { name: '#PASSWORD.TITLE', route: ['/forgot-password'] },
    multi: true,
  },
  {
    provide: SOFTLINE_CONFIG_SETTINGS,
    multi: true,
    useFactory: () => {
      const userInfo = inject(UserInfoService);
      return {
        key: PASSWORD_SETTINGS_KEY,
        component: SettingsComponent,
        title: '#PASSWORD.SETTINGS.TITLE',
        icon: 'fa-regular fa-key',
        group: 'internal',
        visible: toObservable(userInfo.value).pipe(map((o) => !!o)),
      };
    },
  },
  importProvidersFrom(
    StoreModule.forFeature({
      name: SOFTLINE_FEATURE_PASSWORD,
      feature: PasswordStore.feature,
      providers: [
        {
          provide: PasswordRepository,
          useFactory: () => new PasswordRepository(),
        },
      ],
    })
  ),
];
